import React, { PureComponent } from 'react';
import moment from 'moment';
import { api } from '$app/api';
import { ExpandedRecord } from './historyDetails';
import { formatFriendlyText } from './formatFriendlyText';
import { HistoryIcon, HistoryText } from './styled';
import Table from '../../../../components/Table';
import Tag from '../../../../components/Tag';
import Clickable from '../../../../components/Clickable';
import Modal from '../../../../components/Modal';

export const VEHICLE_WEIGHT_KG = 3000;

export class BookingHistory extends PureComponent {
  state = {
    history: null,
    isPopupOpen: false,
  };

  fetchHistory = async () => {
    try {
      const { data } = await api.get(`bookings/${this.props.bookingId}/history`);
      this.setState({ history: data, isPopupOpen: true });
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const { bookingId, vehicleWeight } = this.props;
    const { history = [], isPopupOpen } = this.state;
    const columns = [
      {
        title: 'Time',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: (t) => moment(t).format('DD MMM, hh:mm a'),
      },
      { title: 'Event', render: (_, record) => formatFriendlyText(record) },
    ];

    return (
      <div>
        <Clickable onClick={this.fetchHistory}>
          <HistoryIcon src="/assets/images/synchronize-time.svg" />
        </Clickable>
        {vehicleWeight > VEHICLE_WEIGHT_KG && (
          <Tag style={{ marginLeft: 7 }} color="#ffa401">
            <b>Heavy Vehicle</b>
          </Tag>
        )}
        <HistoryText>Booking #{bookingId}</HistoryText>
        <Modal
          title="History"
          visible={isPopupOpen}
          width={800}
          onCancel={() => this.setState({ isPopupOpen: false })}
          footer={null}
        >
          <Table
            rowKey={(record) => `${record.createdAt}-${record.eventType || 'history'}`}
            columns={columns}
            expandRowByClick
            expandedRowRender={ExpandedRecord}
            dataSource={history}
          />
        </Modal>
      </div>
    );
  }
}

export default BookingHistory;
